import getTrackingAdapter from 'src/app/dataAnalytics/analyticsAdapterFactory';

export default getTrackingAdapter();
